export default "__VITE_ASSET__b6774ff8__"